import Vue from 'vue'

export default {

  edit (id) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/assignment_terms/${id}/options`
    )
  },

  update (id, optionIds) {
    let requestBody = { id: id, option_ids: optionIds }
    return Vue.http.put(
      `${process.vars.BACKEND_HOST}/api/ui/assignment_terms/${id}/options`, requestBody
    )
  }
}
